module.exports = __webpack_public_path__ + "static/media/email.6890eaf3.svg";